import React, {useMemo} from 'react';

import {
	CommandBarButtonCompat as CommandBarButton,
	IButtonStyles,
	IIconProps,
	TooltipHostCompat as TooltipHost,
} from 'components/FluentUICompat';

import {useLocation, useParams} from 'react-router-dom';

import {useTranslation} from 'react-i18next';

import {
	excelButtonLocation,
	excelButtonDisable,
	tooltipXL,
} from './ExcelExportCommon.react';

interface ExcelButtonProps {
	sortField: string;
	sortOrder: string;
	excelExport: (sortField: string, sortOrder: string) => Promise<void>;
}

export const ExcelExportButton: React.FC<ExcelButtonProps> = props => {
	const {t} = useTranslation();

	const location = useLocation();

	const {
		regulationId,
		regulatoryDocumentId,
		paragraphId,
		requirementId,
		modelSeries,
		generation,
		baselineId,
		id,
	} = useParams();

	const styles: IButtonStyles = useMemo(() => {
		return {root: {height: '100%'}};
	}, []);

	const iconProps: IIconProps = useMemo(() => {
		return {iconName: 'ExcelLogo'};
	}, []);

	const strLocationType: string = useMemo(
		() =>
			excelButtonLocation(location.pathname, {
				regulationId,
				regulatoryDocumentId,
				paragraphId,
				requirementId,
				modelSeries,
				generation,
				baselineId,
				id,
			}),
		[location],
	);

	const getTooltipContent = (): string | undefined => {
		return (
			tooltipXL(strLocationType, t) ??
			t('ExcelExport', {ns: 'components/EntityList/ExcelExport'})
		);
	};

	const handleClick = async () => {
		const {sortField, sortOrder, excelExport} = props;
		await excelExport(sortField, sortOrder);
	};

	return (
		<TooltipHost content={getTooltipContent()}>
			<CommandBarButton
				text={undefined}
				title={t('ExcelExport', {ns: 'components/EntityList/ExcelExport'})}
				ariaLabel={t('ExcelExport', {ns: 'components/EntityList/ExcelExport'})}
				styles={styles}
				iconProps={iconProps}
				onClick={handleClick}
				disabled={false}
			/>
		</TooltipHost>
	);
};
